import React from "react";

const DOMAINS = [
  {
    title: "Verifiable Execution",
    description:
      "Natural-language requests become explicit plans that execute across apps, files, and bounded web flows with step-by-step checks.",
  },
  {
    title: "Replayable Evidence",
    description:
      "Runs persist verification reports, artifacts, branch decisions, and approval crossings so outcomes can be inspected, resumed, and debugged.",
  },
  {
    title: "Companion & Continuity",
    description:
      "Active context, resumable work, project memory, and bounded initiative keep long-running work coherent across days.",
  },
  {
    title: "Native macOS Interaction",
    description:
      "Built with Swift, AppKit, accessibility hierarchy inspection, and browser-window DOM mapping to work with real desktop surfaces.",
  },
  {
    title: "Privacy & Operator Control",
    description:
      "Approval gates, redaction audit trails, retention controls, and allow or deny boundaries keep the operator in charge.",
  },
  {
    title: "Developer-Grade Tooling",
    description:
      "A first-class MCP server, read-only context plane, delegated execution plane, and internal developer tools make the system inspectable.",
  },
];

export default function TechFocus() {
  return (
    <section id="tech" className="section">
      <div className="section-inner">
        <div className="tech__header">
          <p className="tech__label">Technical Focus</p>
          <h2 className="tech__title">What I Build</h2>
          <p className="tech__summary">
            I build agent products that are inspectable, bounded, native to the
            desktop, and useful to technical operators on day one.
          </p>
        </div>
        <div className="tech__grid">
          {DOMAINS.map(({ title, description }) => (
            <div key={title} className="tech-card">
              <h3 className="tech-card__title">{title}</h3>
              <p className="tech-card__description">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
